// Phone number utility functions for NANP (North American Numbering Plan) format
// Formats and validates 10-digit US phone numbers

export const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const phoneNumber = value.replace(/\D/g, '');
    
    // Limit to 10 digits (ignore country code)
    const limited = phoneNumber.substring(0, 10);
    
    // Apply formatting based on length
    if (limited.length >= 6) {
        return `(${limited.substring(0, 3)}) ${limited.substring(3, 6)}-${limited.substring(6)}`;
    } else if (limited.length >= 3) {
        return `(${limited.substring(0, 3)}) ${limited.substring(3)}`;
    } else if (limited.length > 0) {
        return `(${limited}`;
    }
    
    return limited;
};

export const getDigitsOnly = (phoneNumber) => {
    return phoneNumber.replace(/\D/g, '');
};

export const isValidPhoneNumber = (phoneNumber) => {
    const digits = getDigitsOnly(phoneNumber);
    return digits.length === 10 && digits[0] !== '0' && digits[0] !== '1';
};

export const handlePhoneInput = (event, setState, fieldName) => {
    const input = event.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    const newValue = event.target.value;
    
    // Handle backspace/delete operations
    const isDeleting = newValue.length < oldValue.length;
    
    // If user is deleting and cursor is on a formatting character, skip over it
    if (isDeleting && cursorPosition > 0) {
        const charAtCursor = oldValue.charAt(cursorPosition);
        if (charAtCursor === '(' || charAtCursor === ')' || charAtCursor === ' ' || charAtCursor === '-') {
            // Remove the digit before the formatting character instead
            const digitsOnly = getDigitsOnly(oldValue);
            const newDigits = digitsOnly.slice(0, -1);
            const formatted = formatPhoneNumber(newDigits);
            
            setState(prevState => ({
                ...prevState,
                [fieldName]: formatted
            }));
            
            // Set cursor position after the state update
            setTimeout(() => {
                const newCursorPos = Math.min(cursorPosition - 1, formatted.length);
                input.setSelectionRange(newCursorPos, newCursorPos);
            }, 0);
            return;
        }
    }
    
    const formatted = formatPhoneNumber(newValue);
    setState(prevState => ({
        ...prevState,
        [fieldName]: formatted
    }));
    
    // Adjust cursor position after formatting
    if (!isDeleting) {
        setTimeout(() => {
            // Calculate where cursor should be based on number of digits typed
            const digitsBeforeCursor = getDigitsOnly(newValue.substring(0, cursorPosition)).length;
            let newCursorPos = 0;
            let digitCount = 0;
            
            for (let i = 0; i < formatted.length; i++) {
                if (/\d/.test(formatted[i])) {
                    digitCount++;
                    if (digitCount === digitsBeforeCursor) {
                        newCursorPos = i + 1;
                        break;
                    }
                } else if (digitCount < digitsBeforeCursor) {
                    newCursorPos = i + 1;
                }
            }
            
            input.setSelectionRange(newCursorPos, newCursorPos);
        }, 0);
    }
};